<template>
    <div class="app">
        <HeaderDefault />

        <GroupEventPageCoverDefault />

        <GroupDefault />

        <FooterDefault />
    </div>
</template>

<script setup>
import HeaderDefault from '@/components/Header/HeaderDefault.vue'
import FooterDefault from '@/components/Footer/FooterDefault.vue'
import GroupEventPageCoverDefault from '@/components/Group/GroupEventPageCoverDefault.vue'
import GroupDefault from '@/components/Group/GroupDefault.vue'
</script>